import { cn } from '@/lib/utils';

/* ─── Types ────────────────────────────────────────────────────────────────── */

interface MockBannerProps {
  className?: string;
}

/* ─── Component ────────────────────────────────────────────────────────────── */

function MockBanner({ className }: MockBannerProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full',
        'bg-amber-500/8 border border-amber-500/20',
        'text-[10px] font-semibold uppercase tracking-wider text-amber-400/80',
        'select-none shrink-0',
        className
      )}
      title="Esta tela usa dados de demonstracao"
      aria-label="Dados simulados"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-amber-400/70 animate-pulse" aria-hidden="true" />
      mock
    </span>
  );
}

MockBanner.displayName = 'MockBanner';

export { MockBanner };
export type { MockBannerProps };
